/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SingleDetectorConnectorType = {
    DetectorConnectionSystemA: 'DetectorConnectionSystemA',
    DetectorConnectionSystemBnCplus: 'DetectorConnectionSystemBNCplus',
    DetectorConnectionSystemBnt: 'DetectorConnectionSystemBNT',
    DetectorConnectionSystemM: 'DetectorConnectionSystemM',
    DetectorConnectionSystemTnc: 'DetectorConnectionSystemTNC',
    DetectorConnectionSystemF: 'DetectorConnectionSystemF',
    DetectorConnectionSystemIba: 'DetectorConnectionSystemIBA',
    DetectorConnectionSystemLemo: 'DetectorConnectionSystemLEMO',
    DetectorConnectionSystemV: 'DetectorConnectionSystemV',
    None: 'None'
} as const;
export type SingleDetectorConnectorType = typeof SingleDetectorConnectorType[keyof typeof SingleDetectorConnectorType];


export function SingleDetectorConnectorTypeFromJSON(json: any): SingleDetectorConnectorType {
    return SingleDetectorConnectorTypeFromJSONTyped(json, false);
}

export function SingleDetectorConnectorTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SingleDetectorConnectorType {
    return json as SingleDetectorConnectorType;
}

export function SingleDetectorConnectorTypeToJSON(value?: SingleDetectorConnectorType | null): any {
    return value as any;
}

/**
 * Check if a given object implements the SingleDetectorConnectorType interface.
 */
 export function instanceOfSingleDetectorConnectorType(value: any): value is SingleDetectorConnectorType {
    return Object.values(SingleDetectorConnectorType).includes(value)
}

